import {runInAction} from "mobx";
import {observer} from "mobx-react";
import {Button, CheckBox, Column, Row, RowLR, Spinner, Text, TimeSpanInput} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {store} from "../../../../../Store/index.js";
import {Session} from "../../../../../Server/DB/sessions/@Session.js";
import {SessionDetailSideTab, SetCurrentTime} from "../../../../../Store/main/timeline.js";
import {ES, InfoButton, RunInAction, RunInAction_Set, TextPlus, VDateTime} from "web-vcore";
import {useEffect, useState} from "react";
import {Phase} from "../../../../../Server/DB/@Shared/Phase.js";
import {FindPhaseBasedOnSessionEventsBeforeTimeX} from "../../../../@Shared/Processors/BreathProcessor.js";
import {GetSessionProcessors} from "../../../../@Shared/Processors/@ProcessorInstances.js";
import {StartUpload, Timer} from "js-vextensions";
import {VideoRecordingPlayer_instanceInfo} from "./VideoRecordingPlayer.js";
import {BaseComponent} from "react-vextensions";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {RequestSessionBreathData} from "../../../../../Utils/Bridge/Bridge_RemoteUserProcesses.js";
import {gdBelt_rawDataDB} from "../../../../../Utils/IndexedDB/GDBelt_RawDataDB.js";
import moment from "moment";
import {StartDownload_Generic} from "../../../../../Utils/General/Files.js";

function AdjustTime(session: Session, adjustment: number) {
	const uiState = store.main.timeline.sessions;
	RunInAction("AdjustTime", ()=>{
		//const newTime = (uiState.currentTime + adjustment).KeepBetween(session.startTime, session.endTime);
		const newTime = uiState.currentTime + adjustment;
		//uiState.currentTime = newTime;
		SetCurrentTime(newTime, session);
	});
}

function TimeShiftRow(p: {session: Session, text: string, shift: number}) {
	const {session, text, shift} = p;
	return (
		<Row mt={5}>
			<Button p="3px 0" width={80} text={`<- ${text}`} onClick={()=>AdjustTime(session, -shift)}/>
			<Button ml={5} p="3px 0" width={80} text={`-> ${text}`} onClick={()=>AdjustTime(session, shift)}/>
		</Row>
	);
}

export const DetailPanelSettingsUI = observer_mgl((props: {session: Session})=>{
	const {session} = props;
	const uiState = store.main.timeline.sessions;
	const sessionProcessor = GetSessionProcessors().Active;

	const [rawProcessingProgress, setRawProcessingProgress] = useState<number>(0);
	const [simProcessingProgress, setSimProcessingProgress] = useState<number>(0);
	useEffect(()=>{
		//let lastTick_processingProgress = detailPanelEEGProcessor.ProcessingProgress;
		const timer = new Timer(250, ()=>{
			if (sessionProcessor == null) return;
			if (sessionProcessor.RawProcessing_Progress != rawProcessingProgress) {
				setRawProcessingProgress(sessionProcessor.RawProcessing_Progress);
			}
			if (sessionProcessor.Simulation_Progress != simProcessingProgress) {
				setSimProcessingProgress(sessionProcessor.Simulation_Progress);
			}
		}).Start();
		return ()=>timer.Stop();
	});

	const TabButton = (p: {tab: SessionDetailSideTab, icon: string, title: string})=>{
		const selected = uiState.sideTab == p.tab;
		return (
			<Button mdIcon={p.icon} title={p.title} ml={p.tab == SessionDetailSideTab.data ? 0 : 3}
				style={ES(selected && {backgroundColor: "rgba(100,200,100,.5)"})}
				onClick={()=>RunInAction_Set(()=>{uiState.sideTab = p.tab})}/>
		);
	};

	const splitAt = 170;
	return (
		<ScrollView ml={5} style={{width: 280}}>
			{/* tab bar */}
			<Row center>
				<TabButton tab={SessionDetailSideTab.data} icon="database" title="Data"/>
				<TabButton tab={SessionDetailSideTab.view} icon="chart-line" title="View (main graph)"/>
				<TabButton tab={SessionDetailSideTab.video} icon="video" title="Video (background)"/>
				<TabButton tab={SessionDetailSideTab.seekbar} icon="swap-vertical" title="Seek Bar"/>
				<TabButton tab={SessionDetailSideTab.testing} icon="flask" title="Testing"/>
			</Row>

			{uiState.sideTab == SessionDetailSideTab.data && <>
				<Row mt={5}>
					<Text style={{fontSize: 18}}>Data</Text>
					{!sessionProcessor?.processingComplete &&
						//<Text ml={10} style={{fontSize: 12}}>(processing: {detailPanelEEGProcessor.ProcessingProgress.ToPercentStr(0)})</Text>}
						<Text ml={5} style={{fontSize: 12}}>(processing: {rawProcessingProgress.ToPercentStr(0)}, simulating: {simProcessingProgress.ToPercentStr(0)})</Text>}
				</Row>
				<Row mt={5} center>
					<Button p="5px 10px" text="Request remote breath-data" onClick={async()=>{
						const chunksAlreadyStoredLocally = await gdBelt_rawDataDB.GetChunksForSession(session.id);
						RequestSessionBreathData(session.id, async chunks=>{
							console.log("Received remote breath-data chunks for session:", session.id, chunks);
							for (const chunk of chunks) {
								if (chunksAlreadyStoredLocally.some(a=>a.sessionIdPlusStartTime == chunk.sessionIdPlusStartTime)) continue; // skip if already stored
								await gdBelt_rawDataDB.StoreChunkForSession(chunk);
							}
							gdBelt_rawDataDB.NotifyDataChangedForSession(session.id);
						});
					}}/>
					<Button ml={5} mdIcon="download" title="Download breath data as JSON" onClick={async()=>{
						const chunks = await gdBelt_rawDataDB.GetChunksForSession(session.id);
						const data = {
							sessionId: session.id,
							chunks: chunks
						};
						StartDownload_Generic(JSON.stringify(data, null, "\t"), `BreathData_${moment().format("YYYY-MM-DD-HH-mm-ss")}_${session.id}.json`);
					}}/>
					<Button ml={5} mdIcon="upload" title="Upload breath data from JSON" onClick={async()=>{
						const file = (await StartUpload(false))[0];
						const data = JSON.parse(await file.text());
						if (data.chunks && Array.isArray(data.chunks)) {
							for (const chunk of data.chunks) {
								await gdBelt_rawDataDB.StoreChunkForSession(chunk);
							}
							gdBelt_rawDataDB.NotifyDataChangedForSession(session.id);
							console.log("Uploaded breath-data chunks for session:", session.id, "@chunks:", data.chunks);
						}
					}}/>
				</Row>
				<Row mt={5} center>
					<CheckBox text="Use new config" value={uiState.processing_useCurrentConfig} onChange={val=>{
						RunInAction_Set(()=>uiState.processing_useCurrentConfig = val);
					}}/>
					<InfoButton ml={5} text={`
						If selected, the raw eeg/gyro data is reprocessed according to the currently selected engine-config, rather than the engine-config stored in the loaded session.

						The session data is then also resimulated according to the currently-selected engine-config.

						This lets you preview the effects of changed processing settings, on an existing night's data.

						Caveats:
						* The resimulation may be incorrect if some of the relevant data was not recorded. (eg. gyro-data can affect eeg-activity simulation)
						* User-scripts (and effects in general) are not rerun during resimulation, so any operation-manipulating effects they had won't be re-performed.
					`.AsMultiline(0)}/>
					{/*<CheckBox ml={10} text="Resim" enabled={uiState.processing_useCurrentConfig && sessionProcessor.processingComplete}/>*/}
				</Row>
				<Row mt={5}>
					<CheckBox text="Show wakings" value={uiState.showWakings} onChange={val=>RunInAction_Set(()=>uiState.showWakings = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show dreaming periods" value={uiState.showDreamingPeriods} onChange={val=>RunInAction_Set(()=>uiState.showDreamingPeriods = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show snooze periods (BC)" value={uiState.showSnoozePeriods} onChange={val=>RunInAction_Set(()=>uiState.showSnoozePeriods = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show solving periods" value={uiState.showSolvingPeriods} onChange={val=>RunInAction_Set(()=>uiState.showSolvingPeriods = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show DEILD attempts" value={uiState.showDeildAttempts} onChange={val=>RunInAction_Set(()=>uiState.showDeildAttempts = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show vis-prompt periods" value={uiState.showVisPromptPeriods} onChange={val=>RunInAction_Set(()=>uiState.showVisPromptPeriods = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show alert periods" value={uiState.showAlertPeriods} onChange={val=>RunInAction_Set(()=>uiState.showAlertPeriods = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show signals" value={uiState.showSignals} onChange={val=>RunInAction_Set(()=>uiState.showSignals = val)}/>
				</Row>
				<Row mt={5}>
					<CheckBox text="Show baseline" value={uiState.showBaseline} onChange={val=>RunInAction_Set(()=>uiState.showBaseline = val)}/>
				</Row>
				<Text mt={5}>EEG:</Text>
				<Column mt={5} ml={10}>
					<Row center>
						<CheckBox text="Normalize" value={uiState.eeg_normalize} onChange={val=>RunInAction_Set(()=>uiState.eeg_normalize = val)}/>
						<InfoButton ml={5} text="Whether to display the left/right eeg channels with normalization applied. (normalization settings retrieved from session config's eeg section)"/>
					</Row>
					<Row mt={5} center>
						<CheckBox text="Smooth" value={uiState.eeg_smooth} onChange={val=>RunInAction_Set(()=>uiState.eeg_smooth = val)}/>
						<InfoButton ml={5} text="Whether to display the left/right eeg channels with smoothing applied. (smoothing settings retrieved from session config's eeg section)"/>
					</Row>
				</Column>
				<Text mt={5}>Breath/Siren:</Text>
				<Column mt={5} ml={10}>
					<Row center>
						<CheckBox text="Show breath-interval thresholds" value={uiState.breath_showIntervalThresholds} onChange={val=>RunInAction_Set(()=>uiState.breath_showIntervalThresholds = val)}/>
					</Row>
					<Row mt={5} center>
						<CheckBox text="Calculate peaks" value={uiState.breath_calcPeaks} onChange={val=>RunInAction_Set(()=>uiState.breath_calcPeaks = val)}/>
					</Row>
					{/*<Row mt={5} center>
						<CheckBox text="Calculate desync" value={uiState.breath_calcDesync} onChange={val=>RunInAction_Set(()=>uiState.breath_calcDesync = val)}/>
					</Row>*/}
					<Row mt={5} center>
						<CheckBox text="Calculate long-inhales" value={uiState.breath_calcLongInhales} onChange={val=>RunInAction_Set(()=>uiState.breath_calcLongInhales = val)}/>
					</Row>
				</Column>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="Max percentage of the cpu-time to use for background processing of the eeg-data. (starts at view-center and progresses in both directions)">Processing cpu-limit:</TextPlus>
					<Spinner min={1} max={100} enforceRange={true} style={{width: 50}}
						value={uiState.processing_cpuLimit.ToPercent()} onChange={val=>RunInAction_Set(()=>uiState.processing_cpuLimit = val.FromPercent())}/>
					<Text ml={3}>%</Text>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info={`
						Max percentage of the cpu-time to use for background resimulation of the eeg-data. (also does raw-processing, if not yet done so)

						Note that simulation processing always progresses sequentially. (thus, setting processing cpu-limit of 0 will make raw-processing go purely start-to-end as well)
					`.AsMultiline(0)}>Simulation cpu-limit:</TextPlus>
					<Spinner min={1} max={100} enforceRange={true} style={{width: 50}}
						value={uiState.simulation_cpuLimit.ToPercent()} onChange={val=>RunInAction_Set(()=>uiState.simulation_cpuLimit = val.FromPercent())}/>
					<Text ml={3}>%</Text>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="Max percentage of the cpu-time to use for rendering UI updates (eg. chart refreshes), while processing is active.">Rendering cpu-limit:</TextPlus>
					<Spinner min={1} max={100} enforceRange={true} style={{width: 50}}
						value={uiState.rendering_cpuLimit.ToPercent()} onChange={val=>RunInAction_Set(()=>uiState.rendering_cpuLimit = val.FromPercent())}/>
					<Text ml={3}>%</Text>
				</RowLR>
			</>}

			{uiState.sideTab == SessionDetailSideTab.view && <>
				<Row mt={5} style={{fontSize: 18}}>View (main graph)</Row>
				<CurrentTimeRow session={session}/>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="The max view-range length of the detail-panel overlay, in minutes/seconds.">Max view-range:</TextPlus>
					<TimeSpanInput style={{width: 60}} value={uiState.maxViewRange} min={1} onChange={val=>RunInAction_Set(()=>uiState.maxViewRange = val)}/>
					<Button ml={5} p="1px 7px" text="Go" onClick={()=>SetCurrentTime(uiState.currentTime, session, {adjustViewRange: "force", viewRangeOverride: uiState.maxViewRange * 1000})}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="The initial view-range length of the detail-panel overlay, in minutes/seconds.">Initial view-range:</TextPlus>
					<TimeSpanInput style={{width: 60}} value={uiState.initialViewRange} min={1} onChange={val=>RunInAction_Set(()=>uiState.initialViewRange = val)}/>
					<Button ml={5} p="1px 7px" text="Go" onClick={()=>SetCurrentTime(uiState.currentTime, session, {adjustViewRange: "force", viewRangeOverride: uiState.initialViewRange * 1000})}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="Whether to move the view-range forward/backward, as the current-time increases/decreases. (eg. from seek-bar click)">Move view with time:</TextPlus>
					<CheckBox value={uiState.moveViewWithTime} onChange={val=>RunInAction_Set(()=>uiState.moveViewWithTime = val)}/>
					<Button ml={5} p="1px 7px" text="Go" onClick={()=>SetCurrentTime(uiState.currentTime, session, {adjustViewRange: "force"})}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="When a new current-time is set (eg. using seek bar), and the view-range is updated, what portion of the view-range should be prior to the current-time.">Anchor-pos for time:</TextPlus>
					<Spinner min={0} max={100} enforceRange={true} style={{width: 50}}
						value={uiState.viewAnchorPosForTime.ToPercent()} onChange={val=>RunInAction_Set(()=>uiState.viewAnchorPosForTime = val.FromPercent())}/>
					<Text ml={3}>%</Text>
				</RowLR>
				<TimeShiftRow session={session} text=".1s" shift={100}/>
				<TimeShiftRow session={session} text="1s" shift={1000}/>
				<TimeShiftRow session={session} text="10s" shift={10000}/>
				<TimeShiftRow session={session} text="30s" shift={30000}/>
				<TimeShiftRow session={session} text="1m" shift={60000}/>
				<TimeShiftRow session={session} text="5m" shift={5 * 60000}/>
				<TimeShiftRow session={session} text="10m" shift={10 * 60000}/>
			</>}

			{uiState.sideTab == SessionDetailSideTab.video && <>
				<Row mt={5} style={{fontSize: 18}}>Video (background)</Row>
				<Row mt={5}>
					<Text>Video:</Text>
					<CheckBox ml={10} text="Show" value={uiState.video_show} onChange={val=>RunInAction_Set(()=>uiState.video_show = val)}/>
					<CheckBox ml={10} text="Auto-play" value={uiState.video_autoPlay} onChange={val=>RunInAction_Set(()=>uiState.video_autoPlay = val)}/>
				</Row>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Playback speed:</Text>
					<Spinner value={uiState.playbackSpeed} step={.25} max={16} // max: 16 (Electron, 2020-10-21)
						onChange={val=>RunInAction_Set(()=>uiState.playbackSpeed = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info="Whether to move the current-time forward, as a recorded video segment is played.">Move time with video:</TextPlus>
					<CheckBox value={uiState.moveTimeWithVideo} onChange={val=>RunInAction_Set(()=>uiState.moveTimeWithVideo = val)}/>
					<Button ml={5} p="1px 7px" text="Go" onClick={()=>{
						const {videoEl, period} = VideoRecordingPlayer_instanceInfo ?? {};
						if (videoEl && period) {
							const newTime = period.start + (videoEl.currentTime * 1000);
							SetCurrentTime(newTime, session, {fromVideoPlayer: true});
						}
					}}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<TextPlus info={`
						Enter your camera's stream-latency here; estimate by waving, on Tools/Monitor/Camera page. (or compare video and graph timestamps, assuming device clocks match [unlikely])
						
						Playback will then correct for that latency, by considering videos to have started/ended X seconds earlier than the original reception times.
					`.AsMultiline(0)}>Camera latency:</TextPlus>
					<TimeSpanInput style={{width: 60}} largeUnit={undefined} value={uiState.videoLatency} min={0} onChange={val=>RunInAction_Set(()=>uiState.videoLatency = val)}/>
				</RowLR>
			</>}

			{uiState.sideTab == SessionDetailSideTab.seekbar && <>
				<Row mt={5} style={{fontSize: 18}}>Seek bar</Row>
				<Row mt={5}>
					<CheckBox text="Show" value={uiState.seekBar_show} onChange={val=>RunInAction_Set(()=>uiState.seekBar_show = val)}/>
				</Row>
			</>}

			{uiState.sideTab == SessionDetailSideTab.testing && <>
				<TestingTab session={session}/>
			</>}
		</ScrollView>
	);
});

const CurrentTimeRow = observer((props: {session: Session})=>{
	const {session} = props;
	const uiState = store.main.timeline.sessions;
	return (
		<Row mt={5}>
			<CheckBox style={{fontSize: 12}} text="Current time:" value={uiState.showCurrentTime} onChange={val=>RunInAction_Set(()=>uiState.showCurrentTime = val)}/>
			<InfoButton ml={5} text="The current marked-time, displayed with a vertical yellow line. (to hide, disable this)"/>
			<VDateTime dateFormat="YYYY-MM-DD" timeFormat="HH:mm:ss" inputProps={{style: {marginLeft: 5, flex: 1}}}
				value={uiState.currentTime ? moment(uiState.currentTime) : null}
				onChange={val=>val && SetCurrentTime(val?.valueOf(), session, {adjustViewRange: "none"})}/>
		</Row>
	);
});

const TestingTab = observer((props: {session: Session})=>{
	const {session} = props;
	const uiState = store.main.timeline.sessions;
	const sessionProcessor = GetSessionProcessors().Active;
	const breathProcessor = sessionProcessor?.breathProcessor;

	// keep the BreathProcessor's debug-range synced to the current-time + window-length (this triggers a re-processing of the window's instrumentation data)
	// (these are stored as two separate primitive fields rather than an object, so that mobx/mobx-sync ShallowChanged comparisons match by value)
	// (otherwise a fresh object identity each set would retrigger the heavyweight PossiblyRecalcFromLatestConfigAndData)
	const currentTime = uiState.currentTime;
	const debugWindowLength = uiState.longInhaleDebug_windowLength;
	useEffect(()=>{
		if (currentTime == null) return;
		const newEndTime = currentTime + (debugWindowLength * 1000);
		// only update if actually changed (avoid thrash)
		if (uiState.longInhaleDebug_startTime == currentTime && uiState.longInhaleDebug_endTime == newEndTime) return;
		RunInAction_Set(()=>{
			uiState.longInhaleDebug_startTime = currentTime;
			uiState.longInhaleDebug_endTime = newEndTime;
		});
	}, [currentTime, debugWindowLength, uiState]);

	// gather detection configs (use resim/active config when "use current config" is on, else session.config)
	const detectionConfigs = sessionProcessor?.config?.breath?.longInhaleDetectionConfigs ?? session.config.breath.longInhaleDetectionConfigs ?? [];

	// the UI only reads the per-sample instrumentation data from the processor for the sample the user is hovering over (the window from current-time to the hovered sample)
	const hoveredEntry = breathProcessor?.GetLongInhaleDebugSampleAtTime(uiState.hoveredTime);
	const hoveredSample = hoveredEntry?.sample ?? null;
	const hoveredDebug = hoveredEntry?.debug ?? null;
	// the UI has access to the session's events directly, so it looks up the phase here (no need for a processor method/extra stored field)
	/*const hoveredPhase = hoveredSample ? FindPhaseBasedOnSessionEventsBeforeTimeX(session.events, hoveredSample.time) : null;
	const isDreaming = hoveredPhase == Phase.dreaming;*/
	const debugWindowPhase = uiState.longInhaleDebug_startTime == null ? null :
		FindPhaseBasedOnSessionEventsBeforeTimeX(session.events, uiState.longInhaleDebug_startTime);
	const isDreaming = debugWindowPhase == Phase.dreaming;

	// per-config pass/fail for the hovered sample (the only "logic" left in the UI: a flat comparison of the hovered sample's raw metrics against each config's requirements)
	const perConfigResults = hoveredDebug ? detectionConfigs.map((dc, i)=>{
		const duration_s = hoveredDebug.durationSoFar / 1000;
		const minDuration_forPhase = isDreaming ? dc.minDuration_phaseDreaming : dc.minDuration;
		const passed_duration = duration_s >= minDuration_forPhase;
		const passed_ascendHeight = hoveredDebug.ascentSoFar >= dc.minAscendHeight;
		const passed_roughness = hoveredDebug.roughness != null ? hoveredDebug.roughness <= dc.maxRoughness : false;
		const passed_overall = passed_duration && passed_ascendHeight && passed_roughness;
		return {index: i, duration_s, minDuration_forPhase, passed_duration, passed_ascendHeight, passed_roughness, passed_overall};
	}) : [];
	const firstMatchingConfigIndex = perConfigResults.find(r=>r.passed_overall)?.index ?? null;

	return (
		<>
			<Row mt={5} style={{fontSize: 18}}>Testing</Row>
			<CurrentTimeRow session={session}/>

			{/* test-window length spinner (in seconds) */}
			<RowLR mt={5} splitAt={170}>
				<TextPlus info={`
					The length of the test window (in seconds), starting from the current-time onward, to record per-sample long-inhale instrumentation data for.
					(note: the current-time should be placed on a trough, as that)
				`.AsMultiline(0)}>Test window length (s):</TextPlus>
				<Spinner min={1} max={120} step={1} enforceRange={true} style={{width: 60}} value={uiState.longInhaleDebug_windowLength} onChange={val=>RunInAction_Set(()=>uiState.longInhaleDebug_windowLength = val)}/>
			</RowLR>

			{/* hovered-sample details (live while mouse is over the detail-graph) */}
			<Text mt={8} style={{fontSize: 13, fontWeight: "bold"}}>Hovered sample details:</Text>
			{hoveredSample && hoveredDebug ? (
				<>
					<Column mt={3} ml={10} style={{fontSize: 12, padding: "4px 6px", border: "1px solid rgba(150,150,220,.4)", borderRadius: 4}}>
						<Row>
							<Text>Time: </Text>
							<Text ml={5} style={{color: "white"}}>{moment(hoveredSample.time).format("HH:mm:ss")}</Text>
						</Row>
						<Row>
							<Text>Phase (for window): </Text>
							<Text ml={5} style={{color: isDreaming ? "lightgreen" : "white"}}>{debugWindowPhase ?? "unknown"}</Text>
						</Row>
						<Row>
							<Text>Duration (s): </Text>
							<Text ml={5} style={{color: "white", fontWeight: "bold"}}>{(hoveredDebug.durationSoFar / 1000).toFixed(2)}</Text>
						</Row>
						<Row>
							<Text>Ascend-height: </Text>
							<Text ml={5} style={{color: "white", fontWeight: "bold"}}>{hoveredDebug.ascentSoFar.toFixed(3)}</Text>
						</Row>
						<Row>
							<Text>Roughness: </Text>
							<Text ml={5} style={{color: "white", fontWeight: "bold"}}>{hoveredDebug.roughness != null ? hoveredDebug.roughness.toFixed(3) : "(n/a — &lt;2 samples)"}</Text>
						</Row>
					</Column>

					{/* summary line: matched config (for the hovered sample's window) */}
					<Row mt={5}>
						<Text style={{fontSize: 12}}>
							{firstMatchingConfigIndex != null
								? <span style={{color: "lightgreen"}}>Long-inhale DETECTED at hovered point (matched config #{firstMatchingConfigIndex + 1})</span>
								: <span style={{color: "#ff8888"}}>Long-inhale NOT detected at hovered point (no config matched)</span>}
						</Text>
					</Row>

					{/* per-detection-config comparison (for the hovered sample) */}
					<Text mt={5} style={{fontSize: 13, fontWeight: "bold"}}>Long-inhale detection configs ({detectionConfigs.length}):</Text>
					<Column mt={3} ml={10} style={{fontSize: 12}}>
						{detectionConfigs.length == 0 && <Text style={{color: "#ff8888"}}>(no detection-configs present in current config)</Text>}
						{perConfigResults.map((result, i)=>{
							const dc = detectionConfigs[i];
							const passed = result.passed_overall;
							return (
								<Column key={i} mt={5} style={{padding: "4px 6px", border: `1px solid ${passed ? "rgba(120,220,120,.6)" : "rgba(200,80,80,.4)"}`, borderRadius: 4}}>
									<Row>
										<Text style={{fontWeight: "bold", color: passed ? "lightgreen" : "#ff9999"}}>
											Config #{i + 1}{passed ? " — PASS" : " — FAIL"}
										</Text>
									</Row>
									<Row mt={3}>
										<Text>min-duration: </Text>
										<Text ml={5} style={{color: result.passed_duration ? "lightgreen" : "#ff8888"}}>{result.minDuration_forPhase}s</Text>
										<Text ml={8} style={{color: "rgba(220,220,220,.6)"}}>(actual: {result.duration_s.toFixed(2)}s)</Text>
									</Row>
									<Row mt={3}>
										<Text>min-ascend-height: </Text>
										<Text ml={5} style={{color: result.passed_ascendHeight ? "lightgreen" : "#ff8888"}}>{dc.minAscendHeight}</Text>
										<Text ml={8} style={{color: "rgba(220,220,220,.6)"}}>(actual: {hoveredDebug.ascentSoFar.toFixed(3)})</Text>
									</Row>
									<Row mt={3}>
										<Text>max-roughness: </Text>
										<Text ml={5} style={{color: result.passed_roughness ? "lightgreen" : "#ff8888"}}>{dc.maxRoughness}</Text>
										<Text ml={8} style={{color: "rgba(220,220,220,.6)"}}>(actual: {hoveredDebug.roughness != null ? hoveredDebug.roughness.toFixed(3) : "n/a"})</Text>
									</Row>
								</Column>
							);
						})}
					</Column>
				</>
			) : (
				<Text mt={3} ml={10} style={{fontSize: 12, color: "rgba(200,200,200,.7)"}}>
					{uiState.hoveredTime == null
						? "(hover over the detail-graph to inspect a sample within the test window)"
						: "(no instrumentation data at hovered position — set current-time on/near a trough and ensure the hovered point is within the test window and before the next peak)"}
				</Text>
			)}
		</>
	);
});